import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { EventsOverviewPageData, ExtractSwarovskiPageData } from "@swo/storefront";

import { css } from "@emotion/react";

import { CSS_COLORS, CSS_SPACER_SIZES } from "../../../styles/styles-css-variables";
import { AspectRatio } from "../../../components/_shared-components/image-related/AspectRatio";
import React from "react";
import { CSS_MQ } from "../../../styles/breakpoints";
import { getEventDates } from "../../../domain/swarovski-optik/events";
import { FONTS } from "../../../styles/fonts";
import { transformImageIfFromContentful_jpg } from "../../../domain/contentful/transform-image-if-from-contentful";

export const EventsOverviewEvents: ReactTFC<{
  events: ExtractSwarovskiPageData<EventsOverviewPageData>["data"]["events"];
  realLocaleCode: string;
}> = props => {
  return (
    <div
      css={css`
        margin-top: ${CSS_SPACER_SIZES.md};

        display: grid;

        grid-gap: 20px;
        ${CSS_MQ.atLeastMd} {
          grid-template-columns: repeat(2, minmax(0, 1fr));
          grid-gap: 34px;
        }
      `}
    >
      {props.events.map(event => {
        const wrapperStyles = css`
          background-color: ${CSS_COLORS.Grey0};

          background-position: center;
          background-size: cover;

          overflow: hidden;

          display: flex;
          flex-direction: column;
          justify-content: flex-end;

          padding: 12px 20px;
          ${CSS_MQ.atLeastMd} {
            padding: 20px 30px;
          }

          position: relative;

          color: ${CSS_COLORS.White};

          > * {
            z-index: 3;
          }

          &:before {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 50%;
            z-index: 2;
            background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.7));

            border-radius: 8px;
          }
        `;

        return (
          <AspectRatio
            width={16}
            height={10}
            key={event.id}
            asElement={{ tag: "a", link: event.link }}
            attachStyles={css`
              border-radius: 8px;
              overflow: hidden;
            `}
          >
            <img
              src={transformImageIfFromContentful_jpg(event.imageUrl, 500)}
              alt={""}
              css={css`
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                object-fit: cover;

                z-index: 1;
              `}
              loading={"lazy"}
            />

            <div css={wrapperStyles}>
              <span
                css={css`
                  ${FONTS.SwarovskiFutura300};

                  font-size: 24px;
                  letter-spacing: 0.4px;
                  line-height: 26px;

                  ${CSS_MQ.atLeastMd} {
                    font-size: 30px;
                    letter-spacing: 1px;
                    line-height: 30px;
                  }

                  text-transform: uppercase;
                `}
              >
                {event.name}
              </span>

              <span
                css={css`
                  ${FONTS.SwarovskiFutura300};

                  font-size: 16px;
                  letter-spacing: 1px;

                  margin-bottom: 3px;
                `}
              >
                {getEventDates(event.startDate, event.endDate, props.realLocaleCode)} | {event.country}
              </span>

              <div
                css={css`
                  display: flex;
                  flex-wrap: wrap;
                `}
              >
                {event.groupTypes.map(t => (
                  <span
                    css={css`
                      ${FONTS.SwarovskiFutura500};

                      font-size: 16px;
                      letter-spacing: 1px;

                      text-transform: uppercase;
                      margin-right: 20px;
                    `}
                    key={t}
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </AspectRatio>
        );
      })}
    </div>
  );
};
